import { MyThunkResult } from 'store';

import { TravelReportRequest, ReportSummary } from 'models/reportSummary';

import {
  reportSummaryRequest,
  reportSummarySuccess,
  reportSummaryError,
  reportSummaryLoading,
} from '../action-creators/reports';
import { travel, axiosConfig } from '../api';
interface ReportSummaryResponse {
  data: ReportSummary;
}

export const fetchReportSummary = (companyId?: string, filters?: TravelReportRequest): MyThunkResult<Promise<void>> => (
  dispatch,
) => {
  dispatch(reportSummaryLoading(true));

  const startDateFilter = filters?.FilterStartDate ? `FilterStartDate=${filters.FilterStartDate}` : '';

  const endDateFilter = filters?.FilterEndDate ? `&FilterEndDate=${filters.FilterEndDate}` : '';

  return travel
    .get<ReportSummaryResponse>(`/Reports/TravelsListReport?${startDateFilter}${endDateFilter}`, axiosConfig)
    .then((response) => {
      dispatch(reportSummaryRequest(filters));

      const { data } = response.data;

      dispatch(reportSummarySuccess(data as ReportSummary));
    })
    .catch((error) => {
      dispatch(reportSummaryError);
    });
};
